import {
  API_V3_GET_ALL_BATCHES,
  API_V3_GET_BATCH,
  API_V3_UPDATE_BATCH,
  API_V3_ADMIN,
  API_V3_GET_BATCH_STATUS,
  API_V3_GET_BATCH_STUDENTS,
} from "core/constants/strings"
import pn from "core/utils/pn"
import BatchChangeDatasource from "data/dataSource/Common/BatchChangeDataSource"
import { Server } from "core/utils/axios"
import { Auth } from "domain/model/Auth"

const server = new Server()

export default class BatchChangeAPIDatasourceImpl implements BatchChangeDatasource {
  async GetallBatchesDetails(auth: Auth, page: any, limit: any): Promise<any> {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    }).toString()
    const response = server.get(`${pn(API_V3_ADMIN, API_V3_GET_ALL_BATCHES)}?${queryParams}`, {
      Authorization: `Bearer ${auth?.id_token}`,
    })

    return response
  }
  async GetBatchDetails(auth: Auth, name: string): Promise<any> {
    const response = await server.post(
      pn(API_V3_ADMIN, API_V3_GET_BATCH),
      { name: name },
      {
        Authorization: `Bearer ${auth?.id_token}`,
      }
    )
    return response
  }
  async UpdatebatchDetails(auth: Auth, Batchid: string, batch: any): Promise<any> {
    const response = await server.post(
      pn(API_V3_ADMIN, API_V3_UPDATE_BATCH),
      {
        id: Batchid,
        batch,
      },
      {
        Authorization: `Bearer ${auth?.id_token}`,
      }
    )
    return response
  }
  async GetBatchStatus(auth: Auth, batchid: string): Promise<any> {
    const response = await server.get(pn(API_V3_ADMIN, API_V3_GET_BATCH_STATUS, `?batchId=${batchid}`), {
      Authorization: `Bearer ${auth?.id_token}`,
    })
    return response
  }
  async GetBatchStudents(auth: Auth, batchid: string): Promise<any> {
    const response = await server.post(
      pn(API_V3_ADMIN, API_V3_GET_BATCH_STUDENTS),
      { batchId: batchid },
      {
        Authorization: `Bearer ${auth?.id_token}`,
      }
    )
    return response
  }
}
